import { render } from "./ModalSignInNew.vue?vue&type=template&id=625e03e0&scoped=true"
import script from "./ModalSignInNew.vue?vue&type=script&lang=js"
export * from "./ModalSignInNew.vue?vue&type=script&lang=js"

import "./ModalSignInNew.vue?vue&type=style&index=0&id=625e03e0&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625e03e0"]])

export default __exports__